<eui-menu [items]="items"
          [hasFilter]="hasFilter"
          [hasIcons]="hasIcons"
          [hasTooltip]="hasTooltip"
          [expandAllItems]="expandAllItems"
          [isCollapsed]="!(asService.state$ | async).isSidebarOpen && !(asService.state$ | async).isSidebarHover"
          (onItemClicked)="onMenuItemClicked($event)">
</eui-menu>
